import { defineMessages } from 'react-intl';

export default defineMessages({
  filterEditorHeader: {
    description: 'Filter editor header',
    defaultMessage: 'Edit Order Filter',
    id: 'xe2D8G',
  },
  filterEditorCancel: {
    description: 'Filter editor cancel button',
    defaultMessage: 'Cancel',
    id: 'XFJUXl',
  },
  filterEditorSaveChanges: {
    description: 'Filter editor Save changes button',
    defaultMessage: 'Save Changes',
    id: 'zGpXgG',
  },
});
